import { useStore } from '@xyflow/react'

import { GraphColors } from '../../../bpmn-graph.constants'

import { EditingUserRender } from '../bpmn-diagram.types'
import { useCssZoom } from '../css-zoom.context'

// FlxUserInitialsPipe parity
function userInitials(user: EditingUserRender): string {
  const fromName = `${user.firstName?.charAt(0) ?? ''}${user.lastName?.charAt(0) ?? ''}`
  const initials = fromName || (user.userName?.trim().charAt(0) ?? '')

  return initials.toUpperCase()
}

function userDisplayName(user: EditingUserRender): string {
  const fullName = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim()

  return fullName || user.userName
}

const bubbleStyle: React.CSSProperties = {
  width: 18,
  height: 18,
  boxSizing: 'border-box',
  padding: 4,
  background: '#fdb814',
  color: GraphColors.neutral_900,
  borderRadius: '50%',
  fontSize: 7,
  fontWeight: 'bold',
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
}

/**
 * Collaboration presence bubbles anchored to a node's bottom-left corner. These
 * live inside the canvas and therefore zoom with it, so counter-scale by 1/zoom
 * to keep the bubbles 18px.
 */
export default function NodeEditingUsers({ users }: { users: EditingUserRender[] }) {
  const physicalZoom = useStore((state) => state.transform[2])
  const cssZoom = useCssZoom()
  const logicalZoom = physicalZoom / cssZoom

  return (
    <div
      data-testid="bpmn-node-editing-users"
      style={{
        position: 'absolute',
        bottom: 5,
        right: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        transform: `translateX(9px) scale(${1 / logicalZoom})`,
        transformOrigin: 'bottom right',
        pointerEvents: 'all',
      }}
    >
      {users.map((user, index) => (
        <div
          key={user.userName}
          title={userDisplayName(user)}
          style={{ ...bubbleStyle, marginLeft: index === 0 ? 0 : -6 }}
        >
          {userInitials(user)}
        </div>
      ))}
    </div>
  )
}
